<button
  type="button"
  class="treatment-template-row flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors hover:bg-slate-50"
  [attr.aria-label]="row().template.name + ' deposit settings'"
  (click)="openDialog()"
>
  <span class="flex min-w-0 flex-1 flex-col">
    <span class="font-medium">{{ row().template.name }}</span>
    @if (state(); as rowState) {
      @if (rowState.required) {
        @if (rowState.invalid) {
          <span class="text-sm text-amber-600"> Incomplete configuration </span>
        } @else {
          <span class="truncate text-sm text-slate-500">
            {{ rowState.summary }}
          </span>
        }
      } @else {
        <span class="text-sm text-slate-400">No deposit required</span>
      }
    }
  </span>
  @if (state(); as rowState) {
    @if (rowState.required && rowState.invalid) {
      <mat-icon class="shrink-0 text-amber-500">warning_amber</mat-icon>
    }
  }
  <mat-icon class="shrink-0 text-slate-400">chevron_right</mat-icon>
</button>
